module.exports = __webpack_public_path__ + "img/profile-icon.d1bef577.png";